export default __webpack_public_path__ + "static/images/notesIcon.4fea50e5.svg";